<template>
  <LockLoader
    text="Carregando seu pedido no Parcelex"
  />
</template>

<script>
import LockLoader from '@/components/common/LockLoader.vue';

export default {
  name: 'checkout-init',
  components: {
    LockLoader,
  },
};
</script>
